import React, { FC, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthUserContext, useYoConfigSnapshots } from '@yakoffice/yakoffice-firebase';
import { DocumentTitle, ProjectName } from '@yakoffice/shared-components';
import { observer } from 'mobx-react-lite';
import { NavigationRail } from '@yakoffice/navigation-rail';
import styles from './project.module.scss';
import { useProjectThemeContext } from '@yakoffice/project-theme';

export const ProjectTools: FC = observer(() => {

    const authUser = useContext(AuthUserContext);
    const { projectId } = useParams<{ projectId: string }>();
    const { yoConfig, error: yoConfigError } = useYoConfigSnapshots();
    const projectTheme = useProjectThemeContext();

    DocumentTitle(`Tools - ${ProjectName(projectId)} - Portal`);

    return <div className={`${styles.project} project  ${projectTheme.getColor()}`}>
        <NavigationRail toolId="portal" />

        <div className={`${styles.projectContent} projectContent themed-project`}>

            {yoConfig &&
                <img key="webLogo" src={yoConfig?.portalUrl + yoConfig.portalWeblogoRoute} alt="YakOffice"
                     className={styles.yakOfficeLogo} />
            }
            <h1>Welcome to YakOffice, {authUser && authUser.firebaseUser.displayName}</h1>
        </div>
    </div>;
});
